import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  deleteVehicle,
  editVehicle,
  getDetailVehicle,
  getListSkillsetDropdown,
  getListTemperatureCategoryDropdown,
  getListVehicleAdditionalProofs,
  getListVehicleDropdown,
  getManagementHistoryList,
  getMaxOrderUnit,
  getSearchRecommendation,
  getSearchResult,
  getVehicleList,
  initiateVehicle,
  postVehicle,
} from "../../../../service/master/Vehicle/VehicleService";
import { getListTemperatureCategory } from "../../../../service/setup/TemperatureCategory/TemperatureCategoryService";
import moment from "moment/moment";
import { ROUTES } from "../../../../constant/routeConstant";
import { onChanged } from "../../../../util/Util";
import { useRef } from "react";

export const useVehicle = () => {
  const _ = require("lodash");

  const { token } = useSelector((state) => state.auth);
  const [depotKeyword, setDepotKeyword] = useState("");
  const [skillsetKeyword, setSkillsetKeyword] = useState("");
  const [temperatureCategoryKeyword, setTemperatureCategoryKeyword] =
    useState("");

  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [tempCategoryList, setTempCategoryList] = useState([]);
  const [skillsetList, setSkillsetList] = useState([]);
  const [totalData, setTotalData] = useState();
  const [searchKeyword, setSearchKeyword] = useState();
  const [selectedId, setSelectedId] = useState();
  const [selectedUpdatedAt, setSelectedUpdatedAt] = useState();
  const [selectedVehicleType, setSelectedVehicleType] = useState();
  const [selectedVehicleNo, setSelectedVehicleNo] = useState();

  const [options, setOptions] = useState([]);

  const [depotId, setDepotId] = useState("");
  const [ownership, setOwnerShip] = useState("Y");
  const [ownerName, setOwnerName] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [skillSet, setSkillSet] = useState("");
  const [temperatureCategory, setTemperatureCategory] = useState("");
  const [vehicleBrand, setVehicleBrand] = useState("");
  const [vehicleModel, setVehicleModel] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [vehicleNoExpDate, setVehicleNoExpDate] = useState("");
  const [vehicleWeight, setVehicleWeight] = useState("");
  const [chassisNo, setChassisNo] = useState("");
  const [engineNo, setEngineNo] = useState("");
  const [manufacturerYear, setManufacturerYear] = useState(0);
  const [pucNo, setPucNo] = useState("");
  const [insuranceNo, setInsuranceNo] = useState("");
  const [accidentHistory, setAccidentHistory] = useState("");
  const [minOrderUnit, setMinOrderUnit] = useState(0);
  const [maxOrderUnit, setMaxOrderUnit] = useState(0);
  const [minOrderWeight, setMinOrderWeight] = useState(0);
  const [maxOrderWeight, setMaxOrderWeight] = useState(0);
  const [minOrderVolume, setMinOrderVolume] = useState(0);
  const [maxOrderVolume, setMaxOrderVolume] = useState(0);
  const [fixedCost, setFixedCost] = useState("");
  const [variableCost, setVariableCost] = useState(0);
  const [transporterTimeCost, setTransporterTimeCost] = useState(0);
  const [waitingTimeCost, setWaitingTimeCost] = useState(0);
  const [loadingTime, setLoadingTime] = useState(0);
  const [additionalProofValues, setAdditionalProofValues] = useState();
  const [vehicleNumberImage, setVehicleNumberImage] = useState([]);
  const [vehiclePucImage, setVehiclePucImage] = useState([]);
  const [vehicleInsuranceImage, setVehicleInsuranceImage] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedSkillsetId, setSelectedSkillsetId] = useState([]);

  const [temperatureCategoryList, setTemperatureCategoryList] = useState([]);

  const [skillsetError, setSkillsetError] = useState(false);
  const [temperatureCategoryError, setTemperatureCategoryError] =
    useState(false);
  const [plateError, setPlateError] = useState(false);
  const [plateExpError, setPlateExpError] = useState(false);
  const [vehicleWeightError, setVehicleWeightError] = useState(false);
  const [minOrderUnitError, setMinOrderUnitError] = useState(false);
  const [maxOrderUnitError, setMaxOrderUnitError] = useState(false);
  const [minOrderWeightError, setMinOrderWeightError] = useState(false);
  const [maxOrderWeightError, setMaxOrderWeightError] = useState(false);
  const [minOrderVolumeError, setMinOrderVolumeError] = useState(false);
  const [maxOrderVolumeError, setMaxOrderVolumeError] = useState(false);
  const [minMoreThanMaxOrderUnitError, setMinMoreThanMaxOrderUnitError] =
    useState("");
  const [maxLessThanMinOrderUnitError, setMaxLessThanMinOrderUnitError] =
    useState("");
  const [minMoreThanMaxOrderWeightError, setMinMoreThanMaxOrderWeightError] =
    useState("");
  const [maxLessThanMinOrderWeightError, setMaxLessThanMinOrderWeightError] =
    useState("");
  const [minMoreThanMaxOrderVolumeError, setMinMoreThanMaxOrderVolumeError] =
    useState("");
  const [maxLessThanMinOrderVolumeError, setMaxLessThanMinOrderVolumeError] =
    useState("");
  const [fixedCostError, setFixedCostError] = useState(false);
  const [ownerNameError, setOwnerNameError] = useState(false);

  const [selectedDepotId, setSelectedDepotId] = useState();
  const [listDropdown, setListDropdown] = useState([]);

  const [showConfirm, setShowConfirm] = useState(false);

  const [vehicleDetail, setVehicleDetail] = useState();

  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [isDetailLoaded, setIsDetailLoaded] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const [defaultSkillsetList, setDefaultSkillsetList] = useState([]);

  const [additionalProofList, setAdditionalProofList] = useState([]);

  const [sorting, setSorting] = useState(`id asc`);

  const [statePageSize, setStatePageSize] = useState(10);

  const [managementHistoryList, setManagementHistoryList] = useState([]);

  const [maxOrder, setMaxOrder] = useState(0);
  const [parameterError, setParameterError] = useState(false);

  const [minOrderWeightIsBigger, setMinOrderWeightIsBigger] = useState(false);
  const [minOrderUnitIsBigger, setMinOrderUnitIsBigger] = useState(false);
  const [minOrderVolumeIsBigger, setMinOrderVolumeIsBigger] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);

  const maxOrderRef = useRef(null);

  const dispatch = useDispatch();

  const [depotListPage, setDepotListPage] = useState(1);
  const [skillsetListPage, setSkillsetPage] = useState(1);
  const [temperatureCategoryListPage, setTempCategoryListPage] = useState(1);
  const [dropdownListLoading, setDropdownListloading] = useState(false);

  let additionalProof;
  let combinedAdditionalProof = [];
  let tempPlate = [];

  const { client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;

  const toVehicleEdit = (id) => {
    navigate(ROUTES.VEHICLE.EDIT, {
      state: {
        id,
        depot_id: selectedDepotId,
      },
    });
  };

  const toVehicleAdd = () => {
    navigate(ROUTES.VEHICLE.ADD, {
      state: {
        depot_id: selectedDepotId,
      },
    });
  };

  const doSort = (sort) => {
    setSorting(sort);
    doGetListVehicle(1, 10, selectedDepotId, sort);
  };

  const doGetListVehicle = async (page, pageSize, depot_id, sort, keyword) => {
    setSuccessModalOpen(false);

    const param = `page=${page}&limit=${pageSize}&filter=${
      keyword ? `vehicle_type lk ${keyword}, ` : ""
    }depot_id eq ${depot_id ? depot_id : selectedDepotId}&order=${
      sort ? sort : `id asc`
    }`;

    try {
      const response = await getVehicleList(token, null, param, dispatch);
      if (response && response.ok) {
        setList(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const doGetManagementHistoryList = async (id) => {
    try {
      const response = await getManagementHistoryList(
        token,
        null,
        dispatch,
        id
      );
      if (response && response.ok) {
        const data = response.data;
        const reorderedData = [];

        for (let i = data.length - 1; i >= 0; i--) {
          const element = data[i];
          reorderedData.push(element);
        }

        setManagementHistoryList(reorderedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const doGetListVehicleAdditionalProofs = async () => {
    try {
      const response = await getListVehicleAdditionalProofs(
        token,
        null,
        dispatch
      );
      if (response && response.ok) {
        setAdditionalProofList(response.data);
        setIsLoaded(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const doListGetTemperatureCategory = async () => {
    try {
      const response = await getListTemperatureCategory(
        token,
        null,
        null,
        dispatch
      );
      if (response && response.ok) {
        setTempCategoryList(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const doGetListSkillset = async (
    page,
    keyword = "",
    flags = "list",
    depot_id
  ) => {
    const params = {
      page,
      limit: 10,
      filter:
        keyword !== ""
          ? `depot_id eq ${depot_id}, skillset_name lk ${keyword}`
          : `depot_id eq ${depot_id}`,
    };
    try {
      const response = await getListSkillsetDropdown(
        token,
        null,
        params,
        dispatch
      );
      if (response && response.ok) {
        if (flags === "list") {
          if (skillsetList.length === 0) {
            setSkillsetList(response.data);
          } else {
            let tempListDropdown = [...skillsetList];
            response.data.map((item) => tempListDropdown.push(item));
            setSkillsetList(tempListDropdown);
          }
          setDropdownListloading(false);
        } else if (flags === "searchList") {
          setSkillsetList(response.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const doGetDetailVehicle = async (id) => {
    try {
      const response = await getDetailVehicle(token, null, id, dispatch);
      if (response && response.ok) {
        let detail = response.data;
        tempPlate = detail.vehicle_no.split("-");
        setVehicleDetail(detail);
        setVehicleNo(detail.vehicle_no.split("-"));
        setSelectedSkillsetId(detail.skill_set_id);
        setSkillSet(detail.skill_set_id);
        setTemperatureCategory(detail.temperature_category_id);
        setOptions(detail.skill_set);
        setDefaultSkillsetList(detail.skill_set);
        setVehiclePucImage(detail.puc_image === "" ? [] : detail.puc_image);
        setVehicleInsuranceImage(
          detail.insurance_image === "" ? [] : detail.insurance_image
        );
        setVehicleNumberImage(
          detail.vehicle_no_image === "" ? [] : detail.vehicle_no_image
        );
        setIsDetailLoaded(true);
        setMinOrderUnit(detail.min_order_unit);
        setMaxOrderUnit(detail.max_order_unit);
        setMinOrderWeight(detail.min_order_weight);
        setMaxOrderWeight(detail.max_order_weight);
        setMinOrderVolume(detail.min_order_volume);
        setMaxOrderVolume(detail.max_order_volume);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const doGetListTemperatureCategory = async (
    page,
    keyword = "",
    flags = "list"
  ) => {
    const param = {
      page,
      limit: 10,
      filter: keyword !== "" ? `name lk ${keyword}` : "",
    };
    try {
      const response = await getListTemperatureCategoryDropdown(
        token,
        null,
        param,
        dispatch
      );
      if (response && response.ok) {
        if (flags === "list") {
          if (temperatureCategoryList.length === 0) {
            setTemperatureCategoryList(response.data);
          } else {
            let tempListDropdown = [...temperatureCategoryList];
            response.data.map((item) => tempListDropdown.push(item));
            setTemperatureCategoryList(tempListDropdown);
          }
          setDropdownListloading(false);
        } else if (flags === "searchList") {
          setTemperatureCategoryList(response.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const doPostVehicle = async (data) => {
    try {
      const response = await postVehicle(token, null, data, dispatch);
      if (response && response.ok) {
        setSuccessModalOpen(true);
        onChanged(dispatch, false);
      } else {
        if (response.code === "E-4-CMD-DTO-003") {
          setParameterError(true);
          window.scrollTo(0, 0);
          maxOrderRef.current.focus();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const doEditVehicle = async (data, id) => {
    try {
      const response = await editVehicle(token, null, id, data, dispatch);
      if (response && response.ok) {
        setSuccessModalOpen(true);
        setSelectedId();
        onChanged(dispatch, false);
      } else {
        if (response.code === "E-4-CMD-DTO-003") {
          setParameterError(true);
          window.scrollTo(0, 0);
          maxOrderRef.current.focus();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const doGetMaxOrderUnit = async () => {
    try {
      const response = await getMaxOrderUnit(token, null, param, dispatch);
      if (response && response.ok) {
        setMaxOrder(response.data.char_value);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const doInitializeVehicle = async (depot_id, page, pageSize) => {
    const param = `page=${page}&limit=${pageSize}&filter=depot_id eq ${depot_id}`;

    try {
      if (depot_id !== undefined) {
        const response = await initiateVehicle(token, null, param, dispatch);
        if (response && response.ok) {
          setTotalData(response.data.count_data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const doSearch = async (keyword) => {
    try {
      const response = await getSearchRecommendation(
        token,
        null,
        selectedDepotId,
        keyword,
        dispatch
      );
      if (response && response.ok) {
        setOptions(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onSelect = async (keyword) => {
    try {
      const response = await getSearchResult(
        token,
        null,
        selectedDepotId,
        keyword,
        dispatch
      );
      if (response && response.ok) {
        setList(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const doDeleteVehicle = async (id, updated_at) => {
    try {
      const response = await deleteVehicle(
        token,
        null,
        id,
        updated_at,
        dispatch
      );
      if (response && response.ok) {
        setDeleteConfirmationModalOpen(false);
        setSuccessModalOpen(true);
        setSelectedId();
        setSelectedUpdatedAt();
        setSelectedVehicleNo();
        setSelectedVehicleType();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onSearchDDS = (keyword = "", from, depot_id) => {
    switch (from) {
      case "depotList":
        setDepotKeyword(keyword);
        if (keyword.length >= 3 || keyword === "") {
          doGetListDropdown(1, keyword, "searchList");
        }
        setDepotListPage(1);
        break;
      case "skillsetList":
        setSkillsetKeyword(keyword);
        if (keyword.length >= 3 || keyword === "") {
          doGetListSkillset(1, keyword, "searchList", depot_id);
        }
        setSkillsetPage(1);
        break;
      case "temperatureCategoryList":
        setTemperatureCategoryKeyword(keyword);
        if (keyword.length >= 3 || keyword === "") {
          doGetListTemperatureCategory(1, keyword, "searchList");
        }
        setTempCategoryListPage(1);
        break;
      default:
        break;
    }
  };

  const doGetListDropdown = async (page, keyword = "", flags = "list") => {
    setDropdownListloading(true);
    try {
      const response = await getListVehicleDropdown(
        token,
        page,
        keyword,
        null,
        dispatch
      );
      if (response && response.ok) {
        // setSelectedDepotId(response.data[0].id)
        let option = [];
        if (response.data !== null && response.data.length !== undefined) {
          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            let data = {
              id: element.depot_id,
              value: element.depot_name,
            };
            option.push(data);
          }
        }
        if (flags === "list") {
          if (listDropdown.length === 0) {
            setListDropdown(option);
          } else {
            let tempListDropdown = [...listDropdown];
            option.map((item) => tempListDropdown.push(item));
            setListDropdown(tempListDropdown);
          }
          setDropdownListloading(false);
        } else if (flags === "searchList") {
          setListDropdown(option);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onSearch = (event) => {
    setSearchKeyword(event.target.value);
    doSearch(searchKeyword);
  };

  useEffect(() => {
    doGetListDropdown(depotListPage);

    // if (selectedDepotId !== undefined) {
    //     doInitializeVehicle(selectedDepotId, 1, 10)
    //     doGetListVehicle(1, 10, selectedDepotId)
    // }

    doGetListTemperatureCategory(1);
    // if (selectedDepotId) {
    //     setIsLoaded(true)
    // }
  }, []);

  useEffect(() => {
    if (!selectedDepotId && listDropdown?.length > 0) {
      doInitializeVehicle(listDropdown[0]?.id, 1, 10);
      doGetListVehicle(1, 10, listDropdown[0]?.id);
      setSelectedDepotId(listDropdown[0]);
      setIsLoaded(true);
    }
  }, [listDropdown]);

  const onScroll = (event, namespace, depot_id) => {
    let target = event.target;
    switch (namespace) {
      case "depotList":
        if (
          target.scrollHeight - Math.ceil(target.scrollTop) ===
            target.clientHeight ||
          (target.scrollHeight - Math.ceil(target.scrollTop) ===
            target.clientHeight + 1 &&
            !dropdownListLoading)
        ) {
          doGetListDropdown(depotListPage + 1, depotKeyword);
          setDepotListPage(depotListPage + 1);
          target.scrollTo(0, target.scrollHeight);
        }
        break;

      case "skillsetList":
        if (
          target.scrollHeight - Math.ceil(target.scrollTop) ===
            target.clientHeight ||
          (target.scrollHeight - Math.ceil(target.scrollTop) ===
            target.clientHeight + 1 &&
            !dropdownListLoading)
        ) {
          doGetListSkillset(
            skillsetListPage + 1,
            skillsetKeyword,
            "list",
            depot_id
          );
          setSkillsetPage(skillsetListPage + 1);
          target.scrollTo(0, target.scrollHeight);
        }
        break;

      case "temperatureCategoryList":
        if (
          target.scrollHeight - Math.ceil(target.scrollTop) ===
            target.clientHeight ||
          (target.scrollHeight - Math.ceil(target.scrollTop) ===
            target.clientHeight + 1 &&
            !dropdownListLoading)
        ) {
          doGetListTemperatureCategory(
            temperatureCategoryListPage + 1,
            temperatureCategoryKeyword,
            "list"
          );
          setTempCategoryListPage(temperatureCategoryListPage + 1);
          target.scrollTo(0, target.scrollHeight);
        }
        break;

      default:
        break;
    }
  };

  const checkForm = () => {
    if (
      ownership !== "" &&
      skillSet !== "" &&
      temperatureCategory !== "" &&
      vehicleNo !== "" &&
      minOrderUnit !== "" &&
      maxOrderUnit !== "" &&
      minOrderWeight !== "" &&
      maxOrderWeight !== "" &&
      minOrderVolume !== "" &&
      maxOrderVolume !== "" &&
      fixedCost !== 0 &&
      minOrderUnit < maxOrderUnit &&
      minOrderWeight < maxOrderWeight &&
      minOrderVolume < maxOrderVolume
    ) {
      return true;
    } else {
      if (skillSet === "") {
        setSkillsetError(true);
      }
      if (temperatureCategory === "") {
        setTemperatureCategoryError(true);
      }
      if (vehicleNo === "") {
        setPlateError(true);
      }
      if (minOrderUnit === "") {
        setMinOrderUnitError(true);
      }
      if (maxOrderUnit === "") {
        setMaxOrderUnitError(true);
      }
      if (minOrderUnit > maxOrderUnit) {
        setMinMoreThanMaxOrderUnitError(true);
      }
      if (maxOrderUnit < minOrderUnit) {
        setMaxLessThanMinOrderUnitError(true);
      }
      if (minOrderWeight === "") {
        setMinOrderWeight(true);
      }
      if (maxOrderWeight === "") {
        setMaxOrderWeightError(true);
      }
      if (minOrderWeight > maxOrderWeight) {
        setMinMoreThanMaxOrderWeightError(true);
      }
      if (maxOrderWeight < minOrderWeight) {
        setMaxLessThanMinOrderWeightError(true);
      }
      if (minOrderVolume === "") {
        setMinOrderVolumeError(true);
      }
      if (maxOrderVolume === "") {
        setMaxOrderVolumeError(true);
      }
      if (minOrderVolume > maxOrderVolume) {
        setMinMoreThanMaxOrderVolumeError(true);
      }
      if (maxOrderVolume < minOrderVolume) {
        setMaxLessThanMinOrderVolumeError(true);
      }
      if (fixedCost === 0) {
        setFixedCostError(true);
      }
      return false;
    }
  };

  const onChange = (field, value) => {
    onChanged(dispatch, true);
    const newValue = value;

    switch (field) {
      case "ownership":
        if (newValue == "Owned") {
          setOwnerShip("Y");
        } else {
          setOwnerShip("N");
        }
        break;

      case "vehicleOwner":
        if (newValue !== null) {
          setOwnerNameError(false);
          setOwnerName(newValue);
        } else {
          setOwnerNameError(true);
        }
        break;

      case "vehicleType":
        setVehicleType(newValue);
        break;

      case "skillset":
        if (newValue !== null) {
          setSkillsetError(false);
          setSkillSet(newValue);
        } else {
          setSkillsetError(true);
        }
        break;

      case "temperatureCategory":
        if (newValue !== null) {
          setTemperatureCategoryError(false);
          setTemperatureCategory(newValue);
        } else {
          setTemperatureCategoryError(true);
        }
        break;

      case "vehicleBrand":
        setVehicleBrand(newValue);
        break;

      case "vehicleModel":
        setVehicleModel(newValue);
        break;

      case "licencePlateExpired":
        if (newValue !== null) {
          setPlateExpError(false);
          setVehicleNoExpDate(
            moment(newValue, "DD MMMM YYYY").format("YYYY-MM-DD")
          );
        } else {
          setPlateExpError(true);
        }
        break;

      case "vehicleWeight":
        if (newValue !== null) {
          setVehicleWeightError(false);
          setVehicleWeight(newValue);
        } else {
          setVehicleWeightError(true);
        }
        break;

      case "vehicleChassisNo":
        setChassisNo(newValue);
        break;

      case "vehicleEngineNo":
        setEngineNo(newValue);
        break;

      case "manufactureYear":
        setManufacturerYear(_.toInteger(newValue));
        break;

      case "pucNo":
        setPucNo(newValue);
        break;

      case "vehicleInsuranceNo":
        setInsuranceNo(newValue);
        break;

      case "accidentHistory":
        setAccidentHistory(newValue);
        break;

      case "minOrderUnit":
        if (newValue !== null) {
          setMinOrderUnit(newValue);
          setMinOrderUnitError(false);
          if (newValue < maxOrderUnit) {
            setMinMoreThanMaxOrderUnitError(false);
            setMaxLessThanMinOrderUnitError(false);
          }
        } else {
          setMinOrderUnitError(true);
        }
        break;

      case "maxOrderUnit":
        if (newValue !== null) {
          setMaxOrderUnitError(false);
          setMaxOrderUnit(newValue);
          if (newValue > minOrderUnit) {
            setMinMoreThanMaxOrderUnitError(false);
            setMaxLessThanMinOrderUnitError(false);
          }
        } else {
          setMaxOrderUnitError(true);
        }
        break;

      case "minOrderWeight":
        if (newValue !== null) {
          setMinOrderWeightError(false);
          setMinOrderWeight(newValue);
          if (newValue < maxOrderWeight) {
            setMinMoreThanMaxOrderWeightError(false);
            setMaxLessThanMinOrderWeightError(false);
          }
        } else {
          setMinOrderWeightError(true);
        }
        break;

      case `maxOrderWeight`:
        if (newValue !== null) {
          setMaxOrderWeightError(false);
          setMaxOrderWeight(newValue);
          if (newValue > minOrderWeight) {
            setMinMoreThanMaxOrderWeightError(false);
            setMaxLessThanMinOrderWeightError(false);
          }
        } else {
          setMaxOrderWeightError(true);
        }
        break;

      case `minOrderVolume`:
        if (newValue !== null) {
          setMinOrderVolumeError(false);
          setMinOrderVolume(newValue);
          if (newValue < maxOrderVolume) {
            setMinMoreThanMaxOrderVolumeError(false);
            setMaxLessThanMinOrderVolumeError(false);
          }
        } else {
          setMinOrderVolumeError(true);
        }
        break;

      case `maxOrderVolume`:
        if (newValue !== null) {
          setMaxOrderVolumeError(false);
          setMaxOrderVolume(newValue);
          if (newValue > minOrderVolume) {
            setMinMoreThanMaxOrderVolumeError(false);
            setMaxLessThanMinOrderVolumeError(false);
          }
        } else {
          setMaxOrderVolumeError(true);
        }
        break;

      case `fixCost`:
        if (newValue !== null) {
          setFixedCostError(false);
          setFixedCost(newValue);
        } else {
          setFixedCostError(true);
        }
        break;

      case `variableCost`:
        setVariableCost(newValue);
        break;

      case `transporterTimeCost`:
        setTransporterTimeCost(newValue);
        break;

      case `waitingTimeCost`:
        setWaitingTimeCost(newValue);
        break;

      case `loadingTime`:
        setLoadingTime(newValue);
        break;

      case `plate1`:
        if (newValue !== null) {
          if (tempPlate !== "" && newValue !== "") {
            setPlateError(false);
            tempPlate[0] = newValue;
            tempPlate[1] = vehicleNo[1];
            tempPlate[2] = vehicleNo[2];
            setVehicleNo(tempPlate);
          } else {
            setPlateError(true);
          }
        } else {
          setPlateError(true);
        }
        break;

      case `plate2`:
        if (newValue !== null) {
          if (tempPlate[0] !== "" && newValue !== "") {
            setPlateError(false);
            tempPlate[0] = vehicleNo[0];
            tempPlate[1] = newValue;
            tempPlate[2] = vehicleNo[2];
            setVehicleNo(tempPlate);
          } else {
            setPlateError(true);
          }
        } else {
          setPlateError(true);
        }
        break;

      case `plate3`:
        if (newValue !== null) {
          if (tempPlate[0] !== "" && tempPlate[1] !== "" && newValue !== "") {
            setPlateError(false);
            tempPlate[0] = vehicleNo[0];
            tempPlate[1] = vehicleNo[1];
            tempPlate[2] = newValue;
            setVehicleNo(tempPlate);
          } else {
            setPlateError(true);
          }
        } else {
          setPlateError(true);
        }
        break;

      default:
        break;
    }
    // if (field === 'minOrderUnit' || field === 'maxOrderUnit') {
    //     checkIsBigger('orderUnit')
    // } else if (field === 'minOrderWeight' || field === 'maxOrderWeight') {
    //     checkIsBigger('orderWeight')
    // } else if (field === 'minOrderVolume' || field === 'maxOrderVolume') {
    //     checkIsBigger('orderVolume')
    // }
  };

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const monthNumbers = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
      return `${dateFormat.getDate()}-${
        monthNames[dateFormat.getMonth()]
      }-${dateFormat.getFullYear()}`;
    } else {
      return `${dateFormat.getDate()}/${
        monthNumbers[dateFormat.getMonth()]
      }/${dateFormat.getFullYear()}`;
    }
  };

  const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return moment(timestamp).utc().format("HH:mm");
  };

  const additionalProofEditOnChange = (data, value) => {
    additionalProof = {
      id: data.id,
      additional_proof_id: data.additional_proof_id,
      additional_proofs_name: data.additional_proofs_name,
      to_menu_id: data.to_menu_id,
      value: value,
      updated_at: data.updated_at,
    };

    let foundItem = combinedAdditionalProof.find(
      (combinedAdditionalProof) =>
        combinedAdditionalProof["additional_proof_id"] ===
        additionalProof.additional_proof_id
    );

    if (foundItem === undefined) {
      combinedAdditionalProof.push(additionalProof);
    } else {
      const index = combinedAdditionalProof.indexOf(foundItem);
      combinedAdditionalProof.splice(index, 1);
      combinedAdditionalProof.push(additionalProof);
    }
  };

  const additionalProofOnChange = (field, value) => {
    additionalProof = {
      additional_proof_id: _.toInteger(field),
      value: value,
    };

    let foundItem = combinedAdditionalProof.find(
      (combinedAdditionalProof) =>
        combinedAdditionalProof["additional_proof_id"] ===
        additionalProof.additional_proof_id
    );

    if (foundItem === undefined) {
      combinedAdditionalProof.push(additionalProof);
    } else {
      const index = combinedAdditionalProof.indexOf(foundItem);
      combinedAdditionalProof.splice(index, 1);
      combinedAdditionalProof.push(additionalProof);
    }
  };

  const checkIsEdited = () => {
    if (
      ownerName === "" &&
      skillSet === "" &&
      selectedOptions.length === 0 &&
      temperatureCategory === "" &&
      vehicleNo === "" &&
      minOrderUnit === "" &&
      maxOrderUnit === "" &&
      minOrderWeight === "" &&
      maxOrderWeight === "" &&
      minOrderVolume === "" &&
      maxOrderVolume === "" &&
      fixedCost === "" &&
      vehicleModel === "" &&
      vehicleNoExpDate === "" &&
      vehicleWeight === "" &&
      vehicleNo === "" &&
      vehicleType === "" &&
      vehicleBrand === "" &&
      chassisNo === "" &&
      engineNo === "" &&
      manufacturerYear === 0 &&
      pucNo === "" &&
      insuranceNo === "" &&
      accidentHistory === "" &&
      variableCost === 0 &&
      transporterTimeCost === 0 &&
      waitingTimeCost === 0 &&
      loadingTime === 0
    ) {
      toVehicleList();
    } else {
      setShowConfirm(true);
    }
  };

  const checkIsChanged = () => {
    if (
      ownerName === "" &&
      skillSet === "" &&
      temperatureCategory === "" &&
      vehicleNo === "" &&
      minOrderUnit === "" &&
      maxOrderUnit === "" &&
      minOrderWeight === "" &&
      maxOrderWeight === "" &&
      minOrderVolume === "" &&
      maxOrderVolume === "" &&
      fixedCost === "" &&
      vehicleModel === "" &&
      vehicleNoExpDate === "" &&
      vehicleWeight === "" &&
      vehicleNo === "" &&
      vehicleType === "" &&
      vehicleBrand === "" &&
      chassisNo === "" &&
      engineNo === "" &&
      manufacturerYear === 0 &&
      pucNo === "" &&
      insuranceNo === "" &&
      accidentHistory === "" &&
      variableCost === 0 &&
      transporterTimeCost === 0 &&
      waitingTimeCost === 0 &&
      loadingTime === 0
    ) {
      toVehicleList();
    } else {
      setShowConfirm(true);
    }
  };

  const onClear = () => {
    setSearchKeyword();
    doGetListVehicle(1, 10, selectedDepotId, sorting, "");
  };

  const selectDepotId = (id, page, pageLimit) => {
    setSelectedDepotId(id);
    handleChangeLimit(page, pageLimit, id);
  };

  const handleChangeLimit = (page, value, selectedDepotId) => {
    setStatePageSize(value);
    setCurrentPage(page);
    handlePagination(page, value, selectedDepotId);
  };

  const handlePagination = (page, pageSize, selectedDepotId) => {
    doInitializeVehicle(selectedDepotId, page, pageSize);
    doGetListVehicle(page, pageSize, selectedDepotId, sorting, searchKeyword);
  };

  const toVehicleDetail = (id) => {
    navigate(ROUTES.VEHICLE.DETAIL, {
      state: {
        id,
      },
    });
  };

  const toVehicleList = () => {
    navigate(ROUTES.VEHICLE.LIST);
  };

  return {
    list,
    deleteConfirmationModalOpen,
    setDeleteConfirmationModalOpen,
    successModalOpen,
    setSuccessModalOpen,
    navigate,
    doListGetTemperatureCategory,
    doGetListSkillset,
    doPostVehicle,
    depotId,
    ownership,
    ownerName,
    vehicleType,
    skillSet,
    temperatureCategory,
    vehicleBrand,
    vehicleModel,
    vehicleNo,
    vehicleNoExpDate,
    vehicleWeight,
    chassisNo,
    engineNo,
    manufacturerYear,
    pucNo,
    insuranceNo,
    accidentHistory,
    minOrderUnit,
    maxOrderUnit,
    minOrderWeight,
    maxOrderWeight,
    minOrderVolume,
    maxOrderVolume,
    fixedCost,
    variableCost,
    transporterTimeCost,
    waitingTimeCost,
    loadingTime,
    additionalProofValues,
    onChange,
    setVehicleNumberImage,
    setVehiclePucImage,
    setVehicleInsuranceImage,
    vehicleNumberImage,
    vehiclePucImage,
    vehicleInsuranceImage,
    skillsetList,
    temperatureCategoryList,
    setTemperatureCategory,
    totalData,
    handlePagination,
    doGetListVehicle,
    options,
    onSelect,
    onSearch,
    searchKeyword,
    doDeleteVehicle,
    selectedId,
    setSelectedId,
    selectedUpdatedAt,
    setSelectedUpdatedAt,
    selectedVehicleType,
    setSelectedVehicleType,
    selectedVehicleNo,
    setSelectedVehicleNo,
    skillsetError,
    temperatureCategoryError,
    plateError,
    plateExpError,
    vehicleWeightError,
    minOrderUnitError,
    maxOrderUnitError,
    minOrderWeightError,
    maxOrderWeightError,
    minOrderVolumeError,
    maxOrderVolumeError,
    minMoreThanMaxOrderUnitError,
    maxLessThanMinOrderUnitError,
    minMoreThanMaxOrderWeightError,
    maxLessThanMinOrderWeightError,
    minMoreThanMaxOrderVolumeError,
    maxLessThanMinOrderVolumeError,
    fixedCostError,
    setSkillsetError,
    setTemperatureCategoryError,
    setPlateError,
    setPlateExpError,
    setVehicleWeightError,
    setMinOrderUnitError,
    setMaxOrderUnitError,
    setMinOrderWeightError,
    setMaxOrderWeightError,
    setMinOrderVolumeError,
    setMaxOrderVolumeError,
    setMinMoreThanMaxOrderUnitError,
    setMaxLessThanMinOrderUnitError,
    setMinMoreThanMaxOrderWeightError,
    setMaxLessThanMinOrderWeightError,
    setMinMoreThanMaxOrderVolumeError,
    setMaxLessThanMinOrderVolumeError,
    setFixedCostError,
    showConfirm,
    setShowConfirm,
    vehicleDetail,
    toVehicleDetail,
    doGetDetailVehicle,
    isDetailLoaded,
    toVehicleEdit,
    toVehicleList,
    selectDepotId,
    listDropdown,
    doSort,
    sorting,
    setSorting,
    handleChangeLimit,
    statePageSize,
    ownerNameError,
    setOwnerNameError,
    setMinOrderWeight,
    selectedOptions,
    setSelectedOptions,
    selectedSkillsetId,
    setSelectedSkillsetId,
    doEditVehicle,
    checkIsEdited,
    checkIsChanged,
    onClear,
    toVehicleAdd,
    isLoaded,
    doGetListVehicleAdditionalProofs,
    additionalProofList,
    additionalProofOnChange,
    combinedAdditionalProof,
    doGetManagementHistoryList,
    managementHistoryList,
    convertTimestamp,
    convertToTime,
    additionalProofEditOnChange,
    doGetMaxOrderUnit,
    maxOrder,
    parameterError,
    maxOrderRef,
    minOrderUnitIsBigger,
    minOrderWeightIsBigger,
    minOrderVolumeIsBigger,
    currentPage,
    onScroll,
    dropdownListLoading,
    onSearchDDS,
    depotKeyword,
    temperatureCategoryKeyword,
    checkForm,
    selectedDepotId,
  };
};
